import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { useSocket } from '../context/SocketContext';
import boardToast, { TOAST_TYPE } from '../utils/boardToast';
import { CROSS_ICON, PLUS_ICON } from '../assets/image';
import { hasOnlySpecialCharacters } from '../utils/general';
import style from './Milestone.module.css';
import StatusIcon from '../../../../../src/assets/img/statusIcon.svg';
import subtaskStatusIcon from '../../../../../src/assets/img/subtask-status.svg';
import FlagIcon from '../../../../../src/assets/img/flag-icon.svg';
import AssignSelection from './Task/AssignSelection';
import Select from 'react-select';
import CustomDatepicker from '../shared/CustomDatepicker/CustomDatepicker';

export default function AddMilestoneCard({
  projectBoardId,
  statusId,
  statusName,
  isProjectRelatedBoard,
  members,
  priorityOptions,
  setDetailsBox,
  scrollToBottom = () => {},
  reminderOptions,
  isfromCalender = false,
  statusOptions = [],
  defaultDueDate,
  onSaved = () => {},
  isSubtask = false,
  milestoneId = '',
  setShowAddSubtask = () => {},
  setIsAddingMilestone = () => {}
}) {
  const socket = useSocket();
  const draftRef = useRef(null);
  const inputRef = useRef(null);
  const wrapperRef = useRef(null); // 👈 NEW
  const latestValuesRef = useRef({});
  const dropdownRef = useRef(null);
  const memberPopoverRef = useRef(null);
  const { projectId } = useParams();
  const { user } = useAuth();

  const [showInput, setShowInput] = useState(false);
  const [error, setError] = useState('');
  const [milestoneName, setMilestoneName] = useState('');
  const [dueDate, setDueDate] = useState(null);
  const [dateString, setDateString] = useState(null);
  const [kbDueDateReminderId, setkbDueDateReminderId] = useState('');
  const [kbDueDateReminderSet, setkbDueDateReminderSet] = useState(false);
  const [kbDueDateReminders, setkbDueDateReminders] = useState([]);

  const [milestoneStatusId, setMilestoneStatusId] = useState();
  const [milestoneStatusName, setMilestoneStatusName] = useState('');
  const [assignees, setAssignees] = useState([]);
  const [priority, setPriority] = useState('');
  const [dropdownPlacement, setDropdownPlacement] = useState('bottom');
  const [isPriorityOpen, setIsPriorityOpen] = useState(false);

  // useEffect(() => {
  //   if (statusOptions?.length > 0) {
  //     setMilestoneStatusId(statusOptions[0].value);
  //   }
  // }, [statusOptions]);
  useEffect(() => {
    if (defaultDueDate) {
      let dueDateString = '';
      const validDate =
        defaultDueDate === null ? null : defaultDueDate instanceof Date ? defaultDueDate : new Date(defaultDueDate);
      if (validDate) {
        dueDateString = validDate.toLocaleString('en-US', {
          month: 'short', // "Nov"
          day: 'numeric', // "20"
          hour: 'numeric', // "8"
          minute: '2-digit', // "00"
          hour12: true // "PM"
        });
      }
      setDueDate(defaultDueDate);
      setDateString(dueDateString);
    }
  }, [defaultDueDate]);
  useEffect(() => {
    latestValuesRef.current = {
      milestoneName,
      dueDate,
      dateString,
      assignees,
      priority,
      kbDueDateReminders
    };
  }, [milestoneName, dueDate, dateString, assignees, priority, kbDueDateReminders]);

  // useEffect(() => {
  //   if (priorityOptions?.length > 0) {
  //     setPriority(priorityOptions[0].value);
  //   }
  // }, [priorityOptions]);
  // ✅ Always ensure we have "Select" as the first option, even if options are late

  useEffect(() => {
    if (isSubtask && priorityOptions.length > 0) {
      console.log(priorityOptions);

      setPriority(priorityOptions[0].value);
    }
  }, [isSubtask, priorityOptions]);

  useEffect(() => {
    if (isfromCalender || isSubtask) {
      setShowInput(true);
    }
  }, [isfromCalender]);

  const mergedPriorityOptions = useMemo(
    () => [{ label: 'Select', value: '' }, ...(priorityOptions || [])],
    [priorityOptions]
  );

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    // if (showInput) {
    //   setPriority('');
    // }
    // return () => {
    //   setPriority('');
    // };
  }, [showInput]);

  // 👇 Close when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        !memberPopoverRef.current?.contains(event.target)
      ) {
        // Save current draft
        // draftRef.current = latestValuesRef.current;

        setShowInput(false);
        setIsAddingMilestone(false);
        setShowAddSubtask(false);

        if (!isfromCalender && !isSubtask) {
          setDetailsBox(false);
          if(latestValuesRef.current.milestoneName) {
            handleSave();
          } 
        }
      }
    };

    if (showInput) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showInput]);

  const handleSave = () => {
    const { milestoneName, dueDate, dateString, assignees, priority, kbDueDateReminders } = latestValuesRef.current;
    const message = milestoneName;

    if (message?.trim() && hasOnlySpecialCharacters(message)) {
      setError(true);
      boardToast('The input contains only special characters. Please enter valid text.', TOAST_TYPE.ERROR);
      return;
    }
    if (message?.trim()?.length < 2) {
      setError(true);
      boardToast('Min two characters are required', TOAST_TYPE.ERROR);
      return;
    }

    setError(false);

    if (message?.trim()) {
      setShowInput(false);
      setIsAddingMilestone(false);
      setShowAddSubtask(false);
      if (!isfromCalender && !isSubtask) {
        setDetailsBox(false);
      }
      if (statusId || milestoneStatusId || isSubtask) {
        // console.log(priority);
        // console.log(
        //   assignees.map((user) => user._id),
        //   'assignees'
        // );
        // console.log(milestoneStatusName, 'milestoneStatusName');

        let payload;

        if (isSubtask) {
          payload = {
            name: message,
            dueDate: dueDate,
            status: priority, // default "to-do"
            assignees: assignees.map((user) => user._id),
            originalUrl: '',
            kbDueDateString: dateString,
            kbDueDateReminders: kbDueDateReminders
          };
        } else {
          payload = {
            projectId: isProjectRelatedBoard ? projectId : undefined,
            name: message,
            createdBy: user?._id,
            projectBoardId,
            milestoneKBStatus: isfromCalender ? milestoneStatusId : statusId,
            statusName: isfromCalender ? milestoneStatusName : statusName,
            kbDueDate: dueDate,
            kbDueDateString: dateString,
            kbDueDateReminders: kbDueDateReminders,
            assigneeIds: assignees.map((user) => user._id)
          };

          // only add priority if not empty
          if (priority && priority.trim() !== '') {
            payload.priority = priority;
          }
        }

        // if (kbDueDateReminderId) {
        //   payload.kbDueDateReminderId = kbDueDateReminderId;
        // }
        // if (kbDueDateReminderSet) {
        //   payload.assigneeIds.push(user._id);
        // }

        // only add priority if not empty
        // if (priority && priority.trim() !== '') {
        //   payload.priority = priority;
        // }
        if (isSubtask) {
          socket.emit('add-subtask', { ...payload, milestoneId }, projectBoardId);
        } else {
          socket.emit('add-milestone', payload);
        }

        // Reset fields after save
        setMilestoneName('');
        setDueDate(null);
        setPriority();
        setAssignees([]);
        setDateString('');
        setkbDueDateReminders([]);
        if (isfromCalender) {
          onSaved();
        }
      } else {
        boardToast('Status name is required', TOAST_TYPE.ERROR);
      }
    }
  };
  const handleMember = (user) => {
    // console.log(user);

    if (!assignees.find((value) => value._id == user._id)) {
      setAssignees((prev) => [...prev, user]);
    }
  };

  // Remove member
  const handleRemove = (userId) => {
    // console.log(userId);

    setAssignees((prev) => prev.filter((user) => user._id !== userId));
  };

  // 👇 Detect space and adjust dropdown placement
  const handleDropdownOpen = () => {
    if (!dropdownRef.current) return;
    const rect = dropdownRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 200 && spaceAbove > spaceBelow) {
      setDropdownPlacement('top'); // open upward
    } else {
      setDropdownPlacement('bottom'); // open downward
    }
  };

  const handleDueDate = (date, kbDueDateRemindersData = []) => {
    let dueDateString = '';
    const validDate = date === null ? null : date instanceof Date ? date : new Date(date);
    if (validDate) {
      dueDateString = validDate.toLocaleString('en-US', {
        month: 'short', // "Nov"
        day: 'numeric', // "20"
        hour: 'numeric', // "8"
        minute: '2-digit', // "00"
        hour12: true // "PM"
      });
    }
    // if (reminderSet) {
    if (!assignees.find((value) => value._id == user._id)) {
      setAssignees((prev) => [...prev, user]);
    }
    // }
    // setkbDueDateReminderId(reminderId);
    // setkbDueDateReminderSet(reminderSet);
    setkbDueDateReminders(kbDueDateRemindersData);
    setDueDate(validDate);
    setDateString(dueDateString);
  };

  return (
    <div
      className={`${isfromCalender ? style.milestone_calenderCard : ''}`}
      style={{ marginLeft: isSubtask ? '10px' : '' }}>
      <div style={{ position: 'relative', minHeight: '41px', padding: '0 5px 0 0' }} className={style.addMilestoneCard}>
        {showInput ? (
          <div
            className={style.milestone_edit_card_wrapper}
            // style={error ? { borderColor: '#D11A1A ' } : {}}
            // style={{
            //   position: 'absolute',
            //   bottom: '0%', // 👈 open upwards
            //   // marginBottom: '8px', // small spacing
            //   zIndex: 10,
            //   borderColor: error ? '#D11A1A' : undefined
            // }}
            ref={wrapperRef}>
            <div className={style.milestone_name_cover}>
              <input
                ref={inputRef}
                placeholder={isSubtask ? 'Subtask Name...' : 'Task Name...'}
                value={milestoneName}
                onChange={(e) => {
                  setMilestoneName(e.target.value);
                  setError(false);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleSave();
                }}
                maxLength={80}
              />
              <button
                className={style.save_btn}
                onClick={handleSave}
                style={{
                  opacity: isfromCalender
                    ? milestoneStatusId && milestoneName.trim().length >= 2
                      ? 1
                      : 0.5
                    : milestoneName.trim().length >= 2
                      ? 1
                      : 0.5,
                  pointerEvents: isfromCalender
                    ? milestoneStatusId && milestoneName.trim().length >= 2
                      ? 'auto'
                      : 'none'
                    : milestoneName.trim().length >= 2
                      ? 'auto'
                      : 'none'
                }}>
                Save
              </button>
            </div>

            <div className={style.add_right_member}>
              {isfromCalender && (
                <div className={style.dropdown_priority} onClick={handleDropdownOpen}>
                  <img src={StatusIcon} alt="FlagIcon-icon" className="FlagIcon" />
                  <Select
                    value={statusOptions.find((opt) => opt.value === milestoneStatusId) || null}
                    onChange={(opt) => {
                      setMilestoneStatusId(opt?.value || '');
                      setMilestoneStatusName(opt?.label || '');
                    }}
                    options={statusOptions}
                    placeholder="Priority"
                    className={`${style.priority_select_box} cursor_pointer ${
                      milestoneStatusId && isfromCalender ? 'w-100 ' : style.position_absolute
                    }`}
                    menuPosition="fixed"
                    isSearchable={false}
                    // components={{
                    //   Option: (props) => {
                    //     const labelClass = props.data.label.toLowerCase().replace(/\s+/g, '-');
                    //     const selectedClass = props.isSelected ? 'selected' : '';
                    //     return (
                    //       <div {...props.innerProps} className={`css-10wo9uf-option ${labelClass} ${selectedClass}`}>
                    //         {props.data.label}
                    //       </div>
                    //     );
                    //   }
                    // }}
                  />
                </div>
              )}
              <div className={style.add_mamber}>
                <AssignSelection
                  assignees={assignees}
                  members={members}
                  handleMember={handleMember}
                  handleRemove={handleRemove}
                  isMilestoneBoard={true}
                  popoverRef={memberPopoverRef}
                />
              </div>

              <div
                className={`${style.dropdown_date_picker_wrapper} ${
                  dueDate && isfromCalender ? style.display_block : style.display_none
                }`}
                onMouseDown={(e) => e.stopPropagation()}>
                {/* <img src={TimeIcon} alt="TimeIcon-icon" className="TimeIcon" /> */}
                {/* <DatePicker
                  selected={dueDate}
                  onChange={(date) => setDueDate(date)}
                  className={style.dropdown_date_picker}
                  placeholderText="Select Date"
                  dateFormat="MMM d, h:mm aa"
                  // showTimeSelect
                  minDate={new Date()}
                /> */}
                <CustomDatepicker
                  defaultDate={dueDate}
                  handleDueDate={handleDueDate}
                  reminderOptionsData={reminderOptions}
                  // milestone={milestone}
                  // containerRef={wrapperRef}
                  showDateOnly={false}
                  isNewMilestone={true}
                  viewMode={isfromCalender}
                />
              </div>

              <div
                className={`${style.dropdown_priority} ${style.with_bgcards}`}
                onClick={handleDropdownOpen}
                ref={dropdownRef}>
                {isSubtask ? (
                  <img src={subtaskStatusIcon} alt="FlagIcon-icon" className="FlagIcon" />
                ) : (
                  <img src={FlagIcon} alt="FlagIcon-icon" className="FlagIcon cursor_pointer" />
                )}
                <Select
                  value={mergedPriorityOptions.find((opt) => opt.value === priority) || null}
                  onChange={(opt) => {
                    setPriority(opt?.value || '');
                  }}
                  options={mergedPriorityOptions}
                  placeholder="Priority"
                  className={`${style.priority_select_box} cursor_pointer ${
                    priority && isfromCalender ? 'w-100 ' : style.position_absolute
                  }
  `}
                  menuPosition="fixed"
                  isSearchable={false}
                  classNames={{
                    singleValue: () => {
                      const selectedOption = mergedPriorityOptions.find((o) => o.value === priority);
                      return selectedOption ? selectedOption.label.toLowerCase() : '';
                    }
                  }}
                  components={{
                    Option: (props) => {
                      const labelClass = props.data.label.toLowerCase().replace(/\s+/g, '-');
                      const selectedClass = props.isSelected ? 'selected' : '';
                      return (
                        <div {...props.innerProps} className={`css-10wo9uf-option ${labelClass} ${selectedClass}`}>
                          {props.data.label}
                        </div>
                      );
                    }
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div
            className={style.add_new_milestone}
            onClick={() => {
              setShowInput(true);
              setIsAddingMilestone(true);

              if (draftRef.current) {
                setMilestoneName(draftRef.current.milestoneName || '');
                setDueDate(draftRef.current.dueDate || null);
                setDateString(draftRef.current.dateString || '');
                setAssignees(draftRef.current.assignees || []);
                setPriority(draftRef.current.priority || '');
                setkbDueDateReminders(draftRef.current.kbDueDateReminders || []);
              }

              if (!isfromCalender && !isSubtask) {
                setDetailsBox(true);
              }

              scrollToBottom();
            }}>
            <div className={style.image_wrapper}>
              <img src={PLUS_ICON} alt="search-icon" />
            </div>
            <div>Add</div>
          </div>
        )}
      </div>
    </div>
  );
}
